// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"e79de3db","569":"ba2c467b","5163":"aa347433","8572":"dca42b4d"}[chunkId] + ".chunk.css";
};